export default {
    title: 'SnelStart',
    intro: 'Invoices and credit notes issued for {website} are booked in its SnelStart administration.',
    noWebsite: 'Pick a website first to manage its SnelStart connection.',
    saved: 'SnelStart settings saved.',
    platform: {
        title: 'SnelStart is not set up on this platform yet.',
        body: 'The platform needs its SnelStart subscription key before anything can be booked. You can already enter the koppelsleutel and the options.',
    },
    connection: {
        title: 'Connection',
        intro: 'Generate a koppelsleutel in SnelStart Web under Koppelingen for this administration, paste it here and save. Test connection then reads the ledger accounts.',
        clientKey: 'Koppelsleutel',
        clientKeySet: 'Set: type a new one to replace it',
        clientKeyHint: 'Stored encrypted and never shown again.',
        test: 'Test connection',
        testOk: 'Connected: {count} ledger accounts read.',
        lastTestOk: 'Last test {date}: connected.',
        lastTestFailed: 'Last test {date} failed: {error}',
    },
    ledgers: {
        title: 'Ledger accounts',
        intro: 'Which ledger account each kind of revenue is booked on. One line per VAT rate goes on the account picked here.',
        none: 'Not booked here',
        reload: 'Reload accounts',
        notLoaded: 'Test the connection to load the ledger accounts of the administration.',
        requiredNote: '* needed before the connection can be switched on. The others only when the shop makes such sales.',
    },
    categories: {
        high: 'Revenue at the standard rate (21%)',
        low: 'Revenue at the reduced rate (9%)',
        zero: '0% or exempt',
        intra_eu: 'Intra-EU supplies (ICP)',
        export: 'Export outside the EU',
        oss: 'OSS distance sales',
        out_of_scope: 'Gift cards sold',
        shipping: 'Shipping (optional, else in the revenue)',
    },
    options: {
        title: 'Options',
        attachPdf: 'Attach the invoice PDF',
        attachPdfHint: 'The PDF the customer gets is added to the booking in SnelStart.',
        bookFrom: 'Book invoices issued from',
        bookFromHint: 'Earlier invoices are left alone. Set when the connection is first switched on.',
    },
    enabled: {
        title: 'Booking',
        label: 'Book issued invoices in SnelStart',
        hintOn: 'Each invoice and credit note is booked shortly after it is issued.',
        hintOff: 'Nothing is booked while this is off.',
        on: 'Booking in SnelStart is on.',
        off: 'Booking in SnelStart is off.',
        missing: 'Pick a ledger account for: {categories}.',
    },
    bookings: {
        title: 'Bookings',
        allStatuses: 'All statuses',
        status: 'Status',
        invoice: 'Invoice',
        typeInvoice: 'Invoice',
        creditNote: 'Credit note',
        issued: 'Issued',
        customer: 'Customer',
        amount: 'Amount',
        bookedAt: 'Booked {date}',
        sendAgain: 'Send again',
        sendUnbooked: 'Book {n} unbooked invoice | Book {n} unbooked invoices',
        queued: 'Invoice {number} queued for SnelStart.',
        queuedAll: 'No invoices queued. | 1 invoice queued for SnelStart. | {n} invoices queued for SnelStart.',
        empty: 'No bookings yet.',
    },
    status: {
        booked: 'Booked',
        failed: 'Failed',
        pending: 'Waiting',
        skipped: 'Skipped',
    },
};
